import { ArrowRight } from 'lucide-react';
import { Button, cn } from '@ai-tutor/ui';

/**
 * The quiz's one action slot: Submit, then Next in the same place, so the
 * click target stays put.
 *
 * Inline on desktop, where it fades in once an option is picked. `pinned` is
 * the phone's: the runner's footer, full width, and there from the start -
 * Submit disabled until an option is picked - so a bar does not appear under
 * the thumb mid-question, and the answers scroll above it rather than
 * falling below the fold.
 */
export function QuizActions({
  pinned,
  submitted,
  canSubmit,
  onSubmit,
  onNext,
  nextLabel,
}: {
  pinned: boolean;
  submitted: boolean;
  canSubmit: boolean;
  onSubmit: () => void;
  onNext: () => void;
  nextLabel: string;
}) {
  const cls = cn(
    'gap-2',
    pinned
      ? // Disabled as a solid muted fill, not the primitive's 50% opacity -
        // a half-transparent bar let the page show through it.
        'h-12 w-full disabled:bg-muted disabled:text-muted-foreground disabled:opacity-100'
      : 'motion-safe:duration-150 motion-safe:animate-in motion-safe:fade-in'
  );
  if (submitted) {
    return (
      <Button onClick={onNext} className={cls}>
        {nextLabel}
        <ArrowRight className='h-3 w-3' />
      </Button>
    );
  }
  if (!canSubmit && !pinned) return null;
  return (
    <Button onClick={onSubmit} disabled={!canSubmit} className={cls}>
      Submit
      <kbd className='ml-0.5 hidden font-mono text-xs opacity-70 sm:inline'>
        ↵
      </kbd>
    </Button>
  );
}
